import * as React from 'react';
import { Box, Text, Container } from '@chakra-ui/react';
import { Hero } from '../components/Hero';
import { ReadNext } from '../components/ReadNext';
import { Layout } from '../components/Layout';
import { SectionZone } from '../components/SectionZone';
import { SEO } from '../components/SEO';

export default function Page({ pageContext }) {
  const { page } = pageContext;
  const { hero, sections, readNext, slug } = page?.node || {};

  return (
    <Layout>
      {hero && <Hero data={{ ...hero, slug }} />}
      <Box position='relative' zIndex='1' width='100%' background='white'>
        <Container
          display='flex'
          flexDirection='column'
          maxWidth='container.xl'
          gap={[30, 60]}
          pb={30}
          px={{ base: 0 }}
        >
          {sections &&
            sections.map((section, index) => (
              <Box
                as='section'
                marginTop={index === 0 && hero?.image && { base: '0', md: '-100px', xl: '-200px' }}
                key={section._key || section._id}
              >
                <SectionZone section={section} index={index}>
                  {index === 0 && hero.title && (
                    <Box mb={{ base: 20, md: 40 }}>
                      {hero?.title && (
                        <Text
                          as='h1'
                          textStyle='h1'
                          textTransform='uppercase'
                          fontWeight={600}
                          mb={0}
                        >
                          {hero.title}
                        </Text>
                      )}
                      {hero?.subtitle && (
                        <Text textStyle='h3' fontWeight={500} mt={10}>
                          {hero.subtitle}
                        </Text>
                      )}
                    </Box>
                  )}
                </SectionZone>
              </Box>
            ))}
          {readNext && <ReadNext data={readNext} />}
        </Container>
      </Box>
    </Layout>
  );
}

export const Head = ({ pageContext }) => {
  const { page } = pageContext;
  const { title } = page?.node || {};
  return <SEO title={title} />;
};
